import axios from 'axios';
import AccessToken from '@/services/auth';
import signature from '@/services/signature';

const ACCESS_TOKEN = AccessToken();
const BASE_URI = process.env.VUE_APP_API_BASE_URI;

let config = {
	headers: {
		Authorization: 'Bearer ' + ACCESS_TOKEN.token,
		TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
	}
};

class PromotionApi {
	// --- Back-office CRUD (mirror loyalty programs) ---
	async list(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/promotions' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async get(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/promotions/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getCreate(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/promotions/create' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async create(data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/promotions/create' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getUpdate(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/promotions/' + id + '/edit' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async update(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/promotions/' + id + '/edit' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async delete(id) {
		try {
			const response = await axios.delete(BASE_URI + '/v1/promotions/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// --- POS: promotion panel on a bill ---
	async billPromotion(billId) {
		try {
			const response = await axios.get(BASE_URI + '/v1/bills/' + billId + '/promotion' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// รับสิทธิ์ tier ที่ถึงแล้ว (GWP ฿0 / PWP ราคาพิเศษ) — { promotion_item_id }
	async claim(billId, data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/bills/' + billId + '/promotion/claim' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// คืนสต๊อก reward ที่ถูกถอดแบบไม่คืน (sync ตอนครัวทำแล้ว) — กดจากแผงโปรหลังเช็คกับครัว
	async restockReward(billId, reference) {
		try {
			const response = await axios.put(BASE_URI + '/v1/bills/' + billId + '/promotion/reward/' + reference + '/restock' + signature(), {}, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async cancelReward(billId, reference, isRestock = true) {
		try {
			// is_restock: GWP/PWP เลือกคืนวัตถุดิบเข้าสต๊อกไหม — ลงนามไปกับ query
			const response = await axios.delete(BASE_URI + '/v1/bills/' + billId + '/promotion/reward/' + reference + signature('is_restock=' + (isRestock ? 1 : 0)), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

export const Promotion = new PromotionApi();
